import RequestHelp_Wheel from '../Windows/RequestHelp/RequestHelp_Wheel';
import OMT_UI_DrawUtil from '../../OMT_UI/Drawing/OMT_UI_DrawUtil';

const coinText = {
  style: 'font-num-blue',
  fontSize: 36,
  scaleStroke: true,
  align: 'center',
  lineSpacing: -10,
};

const coinTextSpecial = {
  style: 'font-num-orange',
  fontSize: 36,
  scaleStroke: true,
  align: 'center',
  lineSpacing: -10,
};

/**
 * @author Sandra Koo
 * An extention of the RequestHelp_Wheel (because it can be rigged)
 * The wheel starts off spinning and will determine when to stop by checking the prize before stopping
 */
export default class SpinningWheel extends RequestHelp_Wheel {
  constructor(config) {
    super(config);

    this.SpinStates.Idle_Spin = 'IDLESPIN'; // Some more states
    this.SpinStates.Ready_To_Go = 'READYTOGO'; // The state before it starts to spin down

    this.angleOffset = -180; // For text
    this.previousWholeDistance = 0; // For one extra circle
  }

  init(config) {
    this.moreMoneyMode = config.moreMoneyMode; // Determines this more money mode thing, which is used for the coin shop substitute in Non-IAP
    this.premium = config.premium; // Determines to show premium looking wheel or not
    if (!this.premium) {
      this.premium = G.IAP ? G.IAP : false;
    }
    super.init();

    this.wheelDarkOverlay = G.makeImage( // Will need this for brighten() and darken()
      0, 0,
      this.premium ? 'gold_wheel' : 'prize_wheel_2',
      0.5,
      this.wheel,
    );
    this.wheelDarkOverlay.tint = 0x000000;
    this.wheelDarkOverlay.alpha = 0;
    this.wheelDarkOverlay.visible = 0;
  }

  makeWheelImage() {
    if (this.moreMoneyMode || this.premium) {
      return super.makeWheelImage();
    }
    return G.makeImage(0, 0, 'prize_wheel_2', 0.5, null);
  }

  /**
   * Calculates speed between 10~15
   */
  calculateInitialSpinSpeed() {
    this.spinSpeed = game.math.roundTo(game.rnd.between(10000, 15000) / 1000, -5); // I want decimalssss
  }

  /**
   * Calcualtes spin speed and the prize
   */
  calculateSpinSpeedAndPrize() {
    this.resetWheel();
    this.calculateInitialSpinSpeed();

    this.prizeList.predeterminedPrize = this.determinePrize();
    this.resetWheel();
  }

  /**
   * Determines prize if the user is spinning this for the first time
   * @param {number} rng
   * @param {number} total
   */
  firstTimePrize(rng, total) {
    const goodDeals = [];
    for (let i = 0; i < this.prizeList.current.length; i++) {
      const deal = this.prizeList.current[i].goodDeal;
      if (deal) {
        goodDeals.push(i);
      }
    }

    if (goodDeals.length > 0) {
      const section = Math.floor(total / goodDeals.length);
      const chosenPrize = Math.floor(rng / section);
      return goodDeals[chosenPrize];
    }

    return null;
  }

  startTheWheel(forcedState) {
    let fixedForceState = forcedState;
    if (!fixedForceState) {
      fixedForceState = this.SpinStates.Idle_Spin; // Set default state to Idle_Spin instead of the usual Spinning
    }
    super.startTheWheel(fixedForceState);
  }

  /**
   * Resets the wheel back to 0
   */
  resetWheel() {
    this.previousWholeDistance = 0;
    this.spinState = this.SpinStates.Idle;
  }

  /**
   * O goodly update.
   */
  update() {
    if (this.spinState === this.SpinStates.Idle_Spin || this.spinState === this.SpinStates.Ready_To_Go) { // Perpetually spins the wheel
      if (this.container.visible) {
        if (this.spinSpeed) {
          this.wheel.angle += this.spinSpeed;
          const prevDistancePassed = this.distancePassed;
          this.distancePassed += this.spinSpeed;

          if ( // Bounce the pin
            Math.floor(prevDistancePassed / this.angleBetweenPins)
            !== Math.floor(this.distancePassed / this.angleBetweenPins)
          ) { // Passing a pin
            this.checkPointerBounce(false, this.spinSpeed);
          }

          if (this.spinState === this.SpinStates.Ready_To_Go) { // If we're actually ready to go...
            this.initTimeOut(); // Creates a timeout timer in case it fails to get the accurate angle
            this.previousWholeDistance += this.spinSpeed;
            if (this.previousWholeDistance > 360) { // Have we spun an extra circle?
              let dummyGift; // Lets start the simulation!
              const wheelAngle = this.wheel.angle; // Save these
              const curSpin = this.spinSpeed;
              const originalDistance = this.distancePassed;
              this.spinState = this.SpinStates.Testing; // Enter testing
              while (dummyGift == null) {
                dummyGift = this.spinningWheel(true); // Find the time to slow down for prize
              }
              this.spinSpeed = curSpin; // Return back to these
              this.distancePassed = originalDistance;
              this.wheel.angle = wheelAngle;
              if (dummyGift === this.prizeList.predeterminedPrize) { // Is it the true gift?
                this.spinState = this.SpinStates.Spinning; // If so, enter the end spin
              } else { // If not keep spinning
                this.spinState = this.SpinStates.Ready_To_Go;
              }
            }
          }
        }
        this.shine.update();
        this.pointer.update();
      }
    } else {
      super.update();
    }
  }

  /**
   * Returns an array of numbers that are used to modify how the wheel spins.
   * Slightly different from the default
   * @returns Array<number>
   */
  getWheelMods() {
    return [
      0.8,
      -0.5,
      0.983,
    ];
  }

  /**
   * Fills the wheel with the already given prizeList
   */
  fillWheel() {
    let curAngle = 90 + this.angleBetweenPins / 2;

    if (this.labels) {
      for (let i = 0; i < this.labels.length; i++) {
        const oldLabel = this.labels[i];
        this.wheel.removeChild(this.labels[i]);
        oldLabel.destroy(true);
      }
    }

    const wheelLabels = [];
    for (let i = this.prizeList.current.length - 1; i >= 0; i--) {
      const curPrize = this.prizeList.current[i];
      const giftString = OMT_UI_DrawUtil.getGiftString(curPrize.prize); // Gets asset string
      const distance = 145; // Supposed to be the height of the wheel. Centers on the wheel
      const label = this.constructWheelText({ img: giftString, text: `${curPrize.amount}`, special: curPrize.special }, distance);
      label.x = G.lengthDirX(curAngle, distance, false);
      label.y = G.lengthDirY(curAngle, distance, false);
      label.angle = curAngle - 180; // Weird angle
      label.positionAngle = curAngle;
      label.prize = curPrize;

      wheelLabels.push(label);
      curAngle += this.angleBetweenPins;
    }

    for (let i = 0; i < wheelLabels.length; i++) {
      this.wheel.addChild(wheelLabels[i]);
    }

    this.labels = wheelLabels;
  }

  /**
   * Creates the image of the prize. If its a coin, it also has text with it on the bottom
   * giftData = {
   *  img: string,
   *  ?text: string
   * }
   * @param {Object} giftData
   * @param {number} distance //Available text space
   */
  constructWheelText(giftData, distance) {
    const isCoin = giftData.img.indexOf('coin') > -1;
    const giftBox = new Phaser.Group(G.Game, null);
    const giftImage = G.makeImage(0, 0, giftData.img, 0.5, null);
    giftImage.height = this.getIntendedDimensions(isCoin); // Coin should be bigger
    giftImage.width = giftImage.height;

    giftBox.addChild(giftImage);

    const giftString = giftData.text + (isCoin ? '' : 'x');
    const giftText = new G.Text(0, -2, giftString, this.isSpecialStyle(giftData.special), 0.5, distance - 70, 100, false, 'center', false, true, true);
    giftText.x = (giftImage.width / 2) + giftText.width / 2;
    giftBox.addChild(giftText);
    giftText.angle = 180; // Weird angle
    giftImage.angle = 180;

    return giftBox;
  }

  getIntendedDimensions(isCoin) {
    if (isCoin) {
      return 50;
    }
    return 40;
  }

  /**
   * Is the text red or blue?
   * @param {string} amount
   */
  isSpecialStyle(amount) {
    return amount ? coinTextSpecial : coinText;
  }

  /**
   * Dims everything
   */
  darken() {
    this.wheel.addChild(this.wheelDarkOverlay);
    this.wheelDarkOverlay.visible = true;
    game.add.tween(this.wheelDarkOverlay)
      .to({ alpha: 0.5 }, 300, Phaser.Easing.Sinusoidal.InOut, true);

    const curStep = { step: 0 };
    const startTint = this.pointer.tint;
    game.add.tween(curStep)
      .to({ step: 100 }, 300, Phaser.Easing.Sinusoidal.InOut, true)
      .onUpdateCallback(() => {
        const col = Phaser.Color.interpolateColorWithRGB(startTint, 124, 124, 124, 100, curStep.step); // Tints to a mid grey
        this.pointer.tint = Math.abs(col);
      });
  }

  /**
   * Undims everything
   */
  brighten() {
    game.add.tween(this.wheelDarkOverlay)
      .to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.InOut, true)
      .onComplete.add(function temp() {
        this.wheelDarkOverlay.visible = false;
      }, this);

    const curStep = { step: 0 };
    const startTint = this.pointer.tint;
    const tw = game.add.tween(curStep)
      .to({ step: 100 }, 300, Phaser.Easing.Sinusoidal.InOut, false);
    tw.onUpdateCallback(() => {
      const col = Phaser.Color.interpolateColorWithRGB(startTint, 255, 255, 255, 100, curStep.step); // Tints back to off
      this.pointer.tint = Math.abs(col);
    });
    tw.start();
  }
}
